import { PostStatus, PostStatusBadgeFragment } from "gql/graphql";
import Tag from "@/shared/data-display/tag";
import { useTranslations } from "use-intl";

const COLOR_BY_STATUS: Record<PostStatus, string> = {
  [PostStatus.Draft]: "default",
  [PostStatus.OnModeration]: "processing",
  [PostStatus.Published]: "success",
  [PostStatus.Rejected]: "error",
};

export function PostStatusBadge({ post }: { post: PostStatusBadgeFragment }) {
  const t = useTranslations("PostStatus");

  return <Tag color={COLOR_BY_STATUS[post.status]}>{t(post.status)}</Tag>;
}
